export enum FieldMappingEnum {
  CreatedOn = 'createdOn',
  Creator = 'creator', 
  ModifiedOn = 'modifiedOn',
  Modifier = 'modifier',
  AttributeGroupImage = 'attributeGroupImage',
  AttributeName1 = 'attributeName1',
  CompanyName1 = 'companyName1',
  CraftName1 = 'craftName1',
  OrderName1 = 'orderName1',
  ResponsibleCOCompany = 'responsibleCOCompany',
  ResponsibleCO = 'responsibleCO',
  ResponsibleSCCompany = 'responsibleSCCompany',
  ResponsibleSC = 'responsibleSC',
  ResponsibleCTCompany = 'responsibleCTCompany',
  ResponsibleCT = 'responsibleCT',
  DelayGroupSCId = 'delayGroupSCId',
  DelayGroupCTId = 'delayGroupCTId',
  LastActivitySCStatusName1 = 'lastActivitySCStatusName1',
  LastActivityCTStatusName1 = 'lastActivityCTStatusName1',
  LastActivitySCStatusGroupSC = 'lastActivitySCStatusGroupSC',
  LastActivityCOStatusGroupSC = 'lastActivityCOStatusGroupSC',
  LastActivityCOStatusGroupCT = 'lastActivityCOStatusGroupCT',
  LastActivityCTStatusGroupCT = 'lastActivityCTStatusGroupCT',
  Classification1Name1 = 'classification1Name1',
  Classification2Name1 = 'classification2Name1',
  Classification3Name1 = 'classification3Name1',
  Classification4Name1 = 'classification4Name1',
  ProjectSpecificName1 = 'projectSpecificName1',
  ProjectSpecific2Name1 = 'projectSpecific2Name1'
}

export const FIELD_DICT_MAPPING: { [key: string]: string } = {
  [FieldMappingEnum.CreatedOn]: 'CreatedOn',
  [FieldMappingEnum.Creator]: 'Creator',
  [FieldMappingEnum.ModifiedOn]: 'ModifiedOn',
  [FieldMappingEnum.Modifier]: 'Modifier',
  [FieldMappingEnum.AttributeGroupImage]: 'AttributeGroup_Name1',
  [FieldMappingEnum.AttributeName1]: 'Attribute_Name1',
  [FieldMappingEnum.CompanyName1]: 'Company_Name1',
  [FieldMappingEnum.CraftName1]: 'Craft_Name1',
  [FieldMappingEnum.OrderName1]: 'Order_Name1',
  [FieldMappingEnum.ResponsibleCOCompany]: 'ResponsibleCO_Company',
  [FieldMappingEnum.ResponsibleCO]: 'ResponsibleCO',
  [FieldMappingEnum.ResponsibleSCCompany]: 'ResponsibleSC_Company',
  [FieldMappingEnum.ResponsibleSC]: 'ResponsibleSC',
  [FieldMappingEnum.ResponsibleCTCompany]: 'ResponsibleCT_Company',
  [FieldMappingEnum.ResponsibleCT]: 'ResponsibleCT',
  [FieldMappingEnum.DelayGroupSCId]: 'DelayGroupSC_Id',
  [FieldMappingEnum.DelayGroupCTId]: 'DelayGroupCT_Id',
  [FieldMappingEnum.LastActivitySCStatusName1]: 'LastActivitySC_Status_Name1',
  [FieldMappingEnum.LastActivityCTStatusName1]: 'LastActivityCT_Status_Name1',
  [FieldMappingEnum.LastActivitySCStatusGroupSC]: 'LastActivitySC_StatusGroupSC',
  [FieldMappingEnum.LastActivityCOStatusGroupSC]: 'LastActivityCO_StatusGroupSC',
  [FieldMappingEnum.LastActivityCOStatusGroupCT]: 'LastActivityCO_StatusGroupCT',
  [FieldMappingEnum.LastActivityCTStatusGroupCT]: 'LastActivityCT_StatusGroupCT',
  [FieldMappingEnum.Classification1Name1]: 'Classification1_Name1',
  [FieldMappingEnum.Classification2Name1]: 'Classification2_Name1',
  [FieldMappingEnum.Classification3Name1]: 'Classification3_Name1',
  [FieldMappingEnum.Classification4Name1]: 'Classification4_Name1',
  [FieldMappingEnum.ProjectSpecificName1]: 'ProjectSpecific_Name1',
  [FieldMappingEnum.ProjectSpecific2Name1]: 'ProjectSpecific2_Name1'
};

export const EMPTY_FILTER_ID = '9999999999999';
export const EMPTY_FILTER_MARKER = 'EMPTY_STATUS_GROUP';